import api from "./api";

const controller = "/Cargo/";

export const getCargoViewById = async (id) => {
    const response = await api.get(controller + "GetCargoViewById", { params: { id } });
    return response.data?.data !== undefined ? response.data.data : response.data;
};

export const postCargo = async (dataPost) => {
    const response = await api.post(controller + "PostCargo", dataPost);
    return response.data?.data !== undefined ? response.data.data : response.data;
};

export const getsCargoViewSearchBasic = async (descripcion = "", idEstado = 0, idGrupoCargo = 0) => {
    const response = await api.get(controller + "GetsCargoViewSearchBasic", {
        params: { descripcion, idEstado, idGrupoCargo }
    });
    return response.data?.data !== undefined ? response.data.data : response.data;
};

export const annulCargo = (id) =>
    api.post(controller + "AnnulCargo?idCargo=" + id);

export const activeCargo = (id) =>
    api.post(controller + "ActiveCargo?idCargo=" + id);

export default {
    getCargoViewById,
    postCargo,
    getsCargoViewSearchBasic,
    annulCargo,
    activeCargo
};

